/* Baesics — Promo-Bar Rotation + Savings-Pop + Konfetti (Pipeline 8.1.1, baesics.de)
   Geladen (defer) von sections/baesics-promo-bar.liquid.
   Öffentliche API: window.BaesicsPromo = { savingsPop(x, y, text), confetti(x, y), initAll() } */
(function () {
  'use strict';

  /* Doppelt geladen (z. B. Section mehrfach im Template)? Nur Sections re-initialisieren. */
  if (window.BaesicsPromo && window.BaesicsPromo.__baePromo) {
    window.BaesicsPromo.initAll();
    return;
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function supportsWaapi() {
    return typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
  }

  /* ---------------------------------------------------------------------------
     Partikel-Effekte (vom Bundle-Builder aufgerufen; no-op bei reduzierter Bewegung)
     --------------------------------------------------------------------------- */

  var CONFETTI_COLORS = ['#6B1F2A', '#C8A878', '#E8C8CB', '#F5EAEC', '#8B3A44'];

  function burstConfetti(x, y) {
    if (prefersReducedMotion()) return;
    if (!document.body || !supportsWaapi()) return;
    for (var i = 0; i < 28; i++) {
      spawnConfettiBit(x, y, CONFETTI_COLORS[i % CONFETTI_COLORS.length]);
    }
  }

  function spawnConfettiBit(x, y, color) {
    var p = document.createElement('span');
    p.className = 'confetti-bit';
    p.style.position = 'fixed';
    p.style.zIndex = '300';
    p.style.pointerEvents = 'none';
    p.style.width = '8px';
    p.style.height = '12px';
    p.style.borderRadius = '1px';
    p.style.left = x + 'px';
    p.style.top = y + 'px';
    p.style.background = color;
    document.body.appendChild(p);

    var removed = false;
    var remove = function () {
      if (removed) return;
      removed = true;
      if (p.parentNode) p.parentNode.removeChild(p);
    };

    var ang = Math.random() * Math.PI * 2;
    var dist = 60 + Math.random() * 140;
    var dx = Math.cos(ang) * dist;
    var dy = Math.sin(ang) * dist - 100;
    var rot = Math.random() * 720 - 360;
    var scale = 0.4 + Math.random() * 0.6;
    var duration = 950 + Math.random() * 550;

    var anim = p.animate(
      [
        { transform: 'translate(0, 0) rotate(0deg) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx + 'px, ' + (dy + 180) + 'px) rotate(' + rot + 'deg) scale(' + scale + ')', opacity: 0 }
      ],
      { duration: duration, easing: 'cubic-bezier(.17,.67,.3,1)' }
    );
    anim.onfinish = remove;
    anim.oncancel = remove;
    setTimeout(remove, duration + 500); /* Sicherheitsnetz */
  }

  function savingsPop(x, y, text) {
    if (prefersReducedMotion()) return;
    if (!document.body || !supportsWaapi()) return;

    var el = document.createElement('div');
    el.className = 'savings-pop';
    el.style.position = 'fixed';
    el.style.zIndex = '300';
    el.style.pointerEvents = 'none';
    el.style.background = '#6B1F2A';
    el.style.color = '#fff';
    el.style.fontWeight = '800';
    el.style.fontSize = '13px';
    el.style.letterSpacing = '0.04em';
    el.style.padding = '7px 14px';
    el.style.borderRadius = '999px';
    el.style.boxShadow = '0 10px 26px rgba(107, 31, 42, 0.35)';
    el.style.whiteSpace = 'nowrap';
    el.textContent = text;
    el.style.left = x + 'px';
    el.style.top = y + 'px';
    document.body.appendChild(el);

    var removed = false;
    var remove = function () {
      if (removed) return;
      removed = true;
      if (el.parentNode) el.parentNode.removeChild(el);
    };

    var anim = el.animate(
      [
        { transform: 'translate(-50%, 0) scale(.7)', opacity: 0 },
        { transform: 'translate(-50%, -20px) scale(1.1)', opacity: 1, offset: 0.22 },
        { transform: 'translate(-50%, -70px) scale(1)', opacity: 0 }
      ],
      { duration: 1300, easing: 'cubic-bezier(.2,.7,.3,1)' }
    );
    anim.onfinish = remove;
    anim.oncancel = remove;
    setTimeout(remove, 1800); /* Sicherheitsnetz */
  }

  /* ---------------------------------------------------------------------------
     Promo-Bar: Nachrichten-Rotation + Sticky-Offset (--bae-topbar-offset)
     --------------------------------------------------------------------------- */

  var instances = {};

  function initSection(root) {
    if (!root || root.dataset.baePromoInit === 'true') return;
    root.dataset.baePromoInit = 'true';

    var sectionId = root.getAttribute('data-section-id') || 'baesics-promo';
    var msgsWrap = root.querySelector('[data-bae-promo-msgs]');
    var msgs = (msgsWrap || root).querySelectorAll('[data-bae-promo-msg]');
    var interval = parseInt(root.getAttribute('data-rotation'), 10) || 5000;
    var sticky = root.getAttribute('data-sticky') === 'true';
    /* Owner-Schalter "Animationen": bei false auch die JS-Rotation stoppen (nicht
       nur die CSS-Fade) — sonst springt der Text ohne Überblendung um. */
    var animate = root.getAttribute('data-animations') !== 'false';
    var wrapper = root.closest ? root.closest('.shopify-section') || root : root;

    var idx = 0;
    var timer = null;
    var paused = false;

    function show(i) {
      for (var k = 0; k < msgs.length; k++) {
        msgs[k].classList.toggle('is-active', k === i);
      }
    }

    function tick() {
      if (paused) return;
      idx = (idx + 1) % msgs.length;
      show(idx);
    }

    function start() {
      if (timer || msgs.length < 2) return;
      /* Animationen aus (Owner) oder reduzierte Bewegung (OS): keine Rotation —
         erste Nachricht bleibt stehen. */
      if (!animate || prefersReducedMotion()) return;
      timer = setInterval(tick, interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    /* Höhe des fixierten Pipeline-Headers (.js__header__stuck) — wird beim
       Scrollen dynamisch gesetzt/entfernt, daher jedes Mal frisch messen. */
    function stuckHeaderHeight() {
      var hdr = document.querySelector('.js__header__stuck .theme__header');
      /* floor statt round: Offset nie GRÖSSER als die echte Header-Höhe, damit
         der Banner nie eine Lücke darunter lässt (max. minimale Überlappung,
         die der Header verdeckt). Zusammen mit dem -1px im CSS spaltenfrei. */
      return hdr ? Math.floor(hdr.getBoundingClientRect().height) : 0;
    }

    /* Summe der Höhen ALLER aktuell sticky Promo-Bars (nicht nur dieser Instanz) —
       falls jemand zwei sticky Bars stapelt, spiegelt --bae-topbar-offset dann die
       Gesamthöhe, damit Preview-Spalte + Anker-Ziele nicht unter nur einer Bar
       landen. Regelfall (eine Bar) = deren eigene Höhe. */
    function stickyPromoTotalHeight() {
      var total = 0;
      var roots = document.querySelectorAll('[data-baesics-promo][data-sticky="true"]');
      for (var i = 0; i < roots.length; i++) {
        var w = roots[i].closest ? (roots[i].closest('.shopify-section') || roots[i]) : roots[i];
        total += w.offsetHeight || 0;
      }
      return total || wrapper.offsetHeight || root.offsetHeight || 0;
    }

    function setOffset() {
      if (!sticky) return;
      var hdr = stuckHeaderHeight();
      var h = stickyPromoTotalHeight();
      document.documentElement.style.setProperty('--bae-header-offset', hdr + 'px');
      document.documentElement.style.setProperty('--bae-topbar-offset', (hdr + h) + 'px');
    }

    function clearOffset() {
      document.documentElement.style.removeProperty('--bae-header-offset');
      document.documentElement.style.removeProperty('--bae-topbar-offset');
    }

    var onResize = debounce(setOffset, 150);
    var onScroll = debounce(setOffset, 150);
    /* bfcache-Restore (Back/Forward): Offset frisch berechnen, sonst bleibt ein
       evtl. veralteter/leerer Wert bis zum nächsten Scroll stehen. */
    function onPageShow(e) { if (e && e.persisted) setOffset(); }

    function onPause() { paused = true; }
    function onResume() { paused = false; }

    root.addEventListener('mouseenter', onPause);
    root.addEventListener('mouseleave', onResume);
    root.addEventListener('focusin', onPause);
    root.addEventListener('focusout', onResume);

    if (sticky) {
      setOffset();
      window.addEventListener('resize', onResize);
      window.addEventListener('load', setOffset);
      /* .js__header__stuck wird beim Scrollen dynamisch gesetzt/entfernt →
         Offset neu berechnen. Debounced + passiv. */
      window.addEventListener('scroll', onScroll, { passive: true });
      /* Pipelines Basis-Event feuert im 'sticky'-Header-Modus GENAU beim
         Fixieren/Lösen (nicht nur bei Richtungswechsel wie :up/:down) und ist
         un-debounced → schließt das 150ms-Fenster, in dem der Offset sonst
         veraltet ist (Haarlinie/Überlappung). setOffset ist billig. */
      document.addEventListener('theme:scroll', setOffset);
      document.addEventListener('theme:scroll:up', setOffset);
      document.addEventListener('theme:scroll:down', setOffset);
      window.addEventListener('pageshow', onPageShow);
    }

    start();

    instances[sectionId] = {
      sticky: sticky,
      destroy: function () {
        stop();
        root.removeEventListener('mouseenter', onPause);
        root.removeEventListener('mouseleave', onResume);
        root.removeEventListener('focusin', onPause);
        root.removeEventListener('focusout', onResume);
        if (sticky) {
          window.removeEventListener('resize', onResize);
          window.removeEventListener('load', setOffset);
          window.removeEventListener('scroll', onScroll);
          document.removeEventListener('theme:scroll', setOffset);
          document.removeEventListener('theme:scroll:up', setOffset);
          document.removeEventListener('theme:scroll:down', setOffset);
          window.removeEventListener('pageshow', onPageShow);
          /* Geteilte Offset-Variablen nur räumen, wenn keine ANDERE sticky
             Promo-Bar mehr aktiv ist — sonst verliert die verbleibende Bar
             ihren Offset (Anker springen unter die Leiste). */
          var otherSticky = false;
          for (var sid in instances) {
            if (instances.hasOwnProperty(sid) && sid !== sectionId && instances[sid] && instances[sid].sticky) {
              otherSticky = true;
              break;
            }
          }
          if (!otherSticky) clearOffset();
        }
        delete root.dataset.baePromoInit;
      }
    };
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-baesics-promo]');
    for (var i = 0; i < roots.length; i++) {
      initSection(roots[i]);
    }
  }

  /* Theme-Editor: Section neu geladen / entfernt */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-baesics-promo]') : null;
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id && instances[id]) {
      instances[id].destroy();
      delete instances[id];
    }
  });

  window.BaesicsPromo = {
    __baePromo: true,
    initAll: initAll,
    savingsPop: savingsPop,
    confetti: burstConfetti
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
